import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
    },
    {
        path: '/addresscreate',
        name: 'addresscreate',
        component: () => import('../views/AddressCreateView.vue'),
    },
    {
        path: '/addressedit',
        name: 'addressedit',
        component: () => import('../views/AddressEditView.vue'),
    },
    {
        path: '/audios',
        name: 'audios',
        component: () => import('../views/AudiosView.vue'),
    },
    {
        path: '/audiostransfer',
        name: 'audiostransfer',
        component: () => import('../views/AudiosTransferView.vue'),
    },

    {
        path: '/calendar',
        name: 'calendar',
        component: () => import('../views/CalendarView.vue'),
    },
    {
        path: '/ibocontactupdate',
        name: 'ibocontactupdate',
        component: () => import('../views/IBOContactUpdateView.vue'),
    },
    {
        path: '/ibophonevalidation',
        name: 'ibophonevalidation',
        component: () => import('../views/IBOPhoneCodeValidationView.vue'),
    },
    {
        path: '/validate-email',
        name: 'validateemail',
        component: () => import('../views/EmailValidationView.vue'),
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/DashboardView.vue'),
    },
    {
        path: '/externallinks',
        name: 'externallinks',
        component: () => import('../views/ExternalLinksView.vue'),
    },
    {
        path: '/event-access',
        name: 'eventaccess',
        component: () => import('../views/EventAccessView.vue'),
    },
    {
        path: '/ibo',
        name: 'ibo',
        component: () => import('../views/IBOView.vue'),
    },
    {
        path: '/ibocreate',
        name: 'ibocreate',
        component: () => import('../views/IBOCreateView.vue'),
    },
    {
        path: '/iboedit',
        name: 'iboedit',
        component: () => import('../views/IBOEditView.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/LoginView.vue'),
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('../views/LogoutView.vue'),
    },
    {
        path: '/mobile-messaging-policy',
        name: 'mobilemessagingpolicy',
        component: () => import('../views/MobileMessagingPolicyView.vue'),
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/NewsView.vue'),
    },
    {
        path: '/onlineevents',
        name: 'onlineevents',
        component: () => import('../views/OnlineEventsView.vue'),
    },
    {
        path: '/privacy-policy',
        name: 'privacypolicy',
        component: () => import('../views/PrivacyPolicyViewV2.vue'),
    },
    {
        path: '/passwordupdate',
        name: 'passwordupdate',
        component: () => import('../views/PasswordUpdateView.vue'),
    },
    {
        path: '/password-retrieve',
        name: 'passwordretrieve',
        component: () => import('../views/PasswordRetrieveView.vue'),
    },
    {
        path: '/player',
        name: 'player',
        component: () => import('../views/PlayerView.vue'),
    },
    {
        path: '/player-v2',
        name: 'playerv2',
        component: () => import('../views/PlayerV2View.vue'),
    },
    {
        path: '/reports',
        name: 'reports',
        component: () => import('../views/ReportsView.vue'),
    },
    {
        path: '/reportsnotpaidorders',
        name: 'reportsnotpaidorders',
        component: () => import('../views/ReportsNotPaidOrdersView.vue'),
    },
    {
        path: '/reportslos',
        name: 'reportslos',
        component: () => import('../views/ReportsLOSV2View.vue'),
    },
    {
        path: '/reportssalespoints',
        name: 'reportssalespoints',
        component: () => import('../views/ReportsSalesPointsView.vue'),
    },
    {
        path: '/reportstickets',
        name: 'reportstickets',
        component: () => import('../views/ReportsTicketsView.vue'),
    },
    {
        path: '/sms-agreement',
        name: 'smsagreement',
        component: () => import('../views/SMSAgreementView.vue'),
    },
    {
        path: '/losiboedit',
        name: 'losiboedit',
        component: () => import('../views/LOSIBOEditView.vue'),
    },
    {
        path: '/salesorders',
        name: 'salesorders',
        component: () => import('../views/SalesOrdersView.vue'),
    },
    {
        path: '/salesorder',
        name: 'salesorder',
        component: () => import('../views/SalesOrderView.vue'),
    },
    {
        path: '/salesorderdetail',
        name: 'salesorderdetail',
        component: () => import('../views/SalesOrderDetailView.vue'),
    },
    {
        path: '/salesorderaddress',
        name: 'salesorderaddress',
        component: () => import('../views/SalesOrderAddressView.vue'),
    },
    {
        path: '/salesordersummary',
        name: 'salesordersummary',
        component: () => import('../views/SalesOrderSummaryView.vue'),
    },
    {
        path: '/salesorderccpayment',
        name: 'salesorderccpayment',
        component: () => import('../views/SalesOrderCCPaymentView.vue'),
    },
    {
        path: '/salesordersqrccpayment',
        name: 'salesordersqrccpayment',
        component: () => import('../views/SalesOrderSqrCCPaymentView.vue'),
    },
    {
        path: '/salesorderpaymentresult',
        name: 'salesorderpaymentresult',
        component: () => import('../views/SalesOrderPaymentResultView.vue'),
    },
    {
        path: '/sms-terms',
        name: 'smsterms',
        component: () => import('../views/SMSDisclaimerView.vue'),
    },
    {
        path: '/store',
        name: 'store',
        component: () => import('../views/StoreView.vue'),
    },
    {
        path: '/terms-of-service',
        name: 'termsofservice',
        component: () => import('../views/TermsOfServiceView.vue'),
    },
    {
        path: '/theme',
        name: 'theme',
        component: () => import('../views/ThemeView.vue'),
    },
    {
        path: '/tickets',
        name: 'tickets',
        component: () => import('../views/TicketsView.vue'),
    },
    {
        path: '/uservalidation',
        name: 'uservalidation',
        component: () => import('../views/UserValidationView.vue'),
    },
    {
        path: '/mytickets',
        name: 'mytickets',
        component: () => import('../views/MyTicketsView.vue'),
    },
    {
        path: '/ticketstransfer',
        name: 'ticketstransfer',
        component: () => import('../views/TicketsTransferView.vue'),
    },
    {
        path: '/approveprovider',
        name: 'approveprovider',
        component: () => import('../views/ApproveProviderView.vue'),
    },
    {
        path: '/newscreate',
        name: 'newscreate',
        component: () => import('../views/NewsCreateView.vue'),
    },
    {
        path: '/sms-agreement',
        name: 'smsagreement',
        component: () => import('../views/SMSAgreementView.vue'),
    },
    {
        path: '/goalsreport',
        name: 'goalsreport',
        component: () => import('../views/GoalsReportView.vue'),
    },
    {
        path: '/videoplayer',
        name: 'videoplayer',
        component: () => import('../views/VideoPlayerView.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
